/**
* @name: header-left-set
* @author: weiyong
* @date: 2023-11-21 23:35
* @description：header-left-set
* @update: 2023-11-21 23:35
*/
<template>
  <div :class="prefixCls" class="tab-setting" v-if="!userSetting">
    <span class="tab-setting-title">{{t('标签页设置')}}</span>
    <div class="tab-setting-body w100b flex-div">
      <div class="switch-item">
        <div class="switch-label">{{t('标签页')}}</div>
        <a-switch  @change="(checked)=>{change(HandlerEnum.TABS_SHOW,checked)}" v-model:checked="hasTabs"/>
      </div>

      <div class="switch-item">
        <div class="switch-label">{{t('标签刷新按钮')}}</div>
        <a-switch  @change="(checked)=>{change(HandlerEnum.TABS_SHOW_REDO,checked)}" v-model:checked="getShowRedo"/>
      </div>

      <div class="switch-item" v-if="!isFrameLayout">
        <div class="switch-label">{{t('标签快捷按钮')}}</div>
        <a-switch  @change="(checked)=>{change(HandlerEnum.TABS_SHOW_QUICK,checked)}" v-model:checked="getShowQuick"/>
      </div>

      <div class="switch-item" v-if="!isFrameLayout">
        <div class="switch-label">{{t('标签折叠按钮')}}</div>
        <a-switch  @change="(checked)=>{change(HandlerEnum.TABS_SHOW_FOLD,checked)}" v-model:checked="getShowFold"/>
      </div>

      <div class="w100b" style="margin-bottom: 12px;">
        <div style="padding: 12px 0">{{t('标签页风格')}}</div>
        <div style="font-size: 13px;">
          <radio-group @change="(value)=>{change(HandlerEnum.TABS_THEME,tabsTheme)}" v-model:value="tabsTheme">
            <radio value="oldTabs">{{t('传统风格')}}</radio>
            <radio value="newTabs">{{t('互联网风格')}}</radio>
          </radio-group>
        </div>
      </div>


    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "tab-setting",
});
</script>

<script lang="ts" setup>
import {RadioGroup,Radio} from "ant-design-vue";
import {Switch as ASwitch} from "ant-design-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {useI18n} from "vue-i18n";
import {useRootSetting} from "@/hooks/setting/useRootSetting";
import {useMultipleTabSetting} from "@/hooks/setting/useMultipleTabSetting";

const { getShowMultipleTab,getTabTheme,getShowRedo,getShowQuick,getShowFold} = useMultipleTabSetting();

//是否展示tabs
const hasTabs=ref(unref(getShowMultipleTab));
const tabsTheme=ref(unref(getTabTheme)||'newTabs')

const { getShowLogo } = useRootSetting();

const { t } = useI18n();
interface IProps{
  useLayout:string,
  userSetting:boolean
}
const props=withDefaults(defineProps<IProps>(),{
  userSetting:false,
  useLayout:'defaultFrame'
})

const FRAME_LAYOUTS = ['technology', 'classicBlue'];
const isFrameLayout = computed(() => FRAME_LAYOUTS.includes(props.useLayout));

const {prefixCls} = useDesign('header-left-set');
const change=function (event,val){
  baseHandler(event, val)
}
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-header-left-set';

.@{prefix-cls} {
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #fff;
  font-family: PingFangSC-Semibold,PingFang SC;

  .switch-item{
    width:33.33%;
    margin-bottom: 12px;
  }
  .switch-label{
    margin-bottom: 8px;
  }
  .tab-setting-body{
    flex-wrap: wrap;
  }
  .tab-setting-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 14px;
  }
  .itme-title-span{
    text-align: center;
    margin-top: 6px;
  }
  .item-type-sign {
    width: 56px;
    height: 56px;
    padding: 3px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-right: 12px;
  }
}
.sel-icon-color{
  .color-div{
    height:30px;
    border-radius: 4px;
    cursor:pointer;
  }
  .layoutItem-type-sign-icon{
    display: none;
  }
}
</style>
